<template>
  <div
    class="funnel stepper-wrapper"
    :class="{ 'last-step': stepConfirmation }"
  >
    <div
      v-if="!stepConfirmation"
      class="searchbar-wrapper"
    >
      <BookingSearchBar :is-booking-home="false" @search-submit="searchSubmit" />
    </div>
    <BookingSteps
      v-if="Object.keys(translationsStore.translations).length"
      :steps="steps"
      :current-step="bookingStore.step"
      :is-loader-init="isLoaderInit"
    />
  </div>
</template>

<script setup>
import { computed, watch, ref, nextTick } from "vue";

import BookingSteps from "./BookingSteps.vue";
import BookingSearchBar from "./BookingSearchBar.vue";

import { useBookingStore } from "../stores/booking";
import { useTranslationsStore } from "../stores/translations";

const bookingStore = useBookingStore();
const translationsStore = useTranslationsStore();
const isLoaderInit = ref(false);

// Same state logic as your current BookingFunnel.vue implementation.
const steps = computed(() => {
  if (bookingStore.journeyType === "service") {
    return [
      { title: translationsStore.t("step_name_2") },
      { title: translationsStore.t("step_name_3") },
      { title: translationsStore.t("confirmation") },
    ];
  } else {
    return [
      { title: translationsStore.t("step_name_1") },
      { title: translationsStore.t("step_name_2") },
      { title: translationsStore.t("step_name_3") },
      { title: translationsStore.t("confirmation") },
    ];
  }
});
watch(steps, (newVal) => {
  console.log("steps changed →", newVal);
});
const stepConfirmation = computed(() => {
  return (
    (bookingStore.journeyType === "center" && bookingStore.step === 4) ||
    (bookingStore.journeyType === "service" && bookingStore.step === 3)
  );
});
const searchSubmit = (isValidSearch) => {
  if (!isValidSearch) return;
  isLoaderInit.value = true;
  nextTick(() => {
    isLoaderInit.value = false;
  });
};
</script>

<style scoped>
.searchbar-wrapper {
  padding: 1.5rem 0;
  background-color: var(--color-grey-98);
}
.funnel {
  /* overflow-x: hidden; */
}
</style>
